<input
    type="file"
    class="d-none"
    (change)="handleFileInput($event.target.files)"
    [accept]="allowedTypes"
    #fileInput
/>

<div
    (click)="trigger()"
    class="drag-box cursor-pointer p-3"
    appDragDrop
    (fileDropped)="handleFileInput($event.target.files)"
>
    <h4 class="mb-1" *ngIf="!hasFileName">
        <i class="ml-3 fad fa-cloud-upload"></i>&nbsp;&nbsp;
        <strong>Clique</strong> ou <strong>arraste</strong> seu arquivo para cá
    </h4>
    <h4 class="mb-1" *ngIf="hasFileName">
        <i class="ml-3 fad" [class]="fileIcon"></i>&nbsp;&nbsp;
        {{ getFileName() }}
    </h4>
</div>
